export const htmlId: string = 'building-sites-selector';